export const PrivacySettingsTestIds = {
  containerPrivacy: 'container_privacy',
  inputInactivity: 'input_inactivity',
  permissionArrowDown: 'permission_arrow_down',
  permissionAllowallIcon: 'permission_allowall_icon',
  permissionBlockallIcon: 'permission_blockall_icon',
  userPaginator: 'user_paginator',
  permissionTabGroups: 'permission_tab_groups',
  iconKickMember: 'icon_kick_member',
  groupPaginator: 'group_paginator',
  permissionTabServers: 'permission_tab_servers',
  serverPaginator: 'server_paginator',
  privacyButtonSave: 'privacy_button_save',
  buttonInviteuser: 'button_inviteuser',
  buttonInvitegroup: 'button_invitegroup',
  buttonInviteserver: 'button_inviteserver',
  buttonCancelPermission: 'button_cancel_permission',
  groupSelectOption: 'option_group_permission',
  groupSelect: 'select_group_permission'
} as const;
